export enum TaskManagementNoteTypeModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
